import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { getSMPBackendAPIAdmin } from '@/proxy';
import { toResource } from '@/services/resource.service';

function getResourceMe() {
  return getSMPBackendAPIAdmin().resourcesControllerFindMeV1();
}

export function useResourceMe() {
  return useQuery({
    queryKey: queryKeys.resources.me(),
    queryFn: () => getResourceMe(),
    select: (data) => toResource(data),
  });
}
